<script lang="ts">
import { defineComponent, h, shallowRef, unref } from 'vue';

import { omit } from '@components/utils';

import {
  makeDirectionProps,
  makeDisabledProps,
  makeGroupItemProps,
  makeIconProps,
  makeLoadingProps,
  makeReadonlyProps,
  makeSizeProps,
  makeTextProps,
  useRender
} from '../../composable';
import { CdsButton } from '../CdsButton';

import { CdsTabsSymbol } from './shared';

import type { PropType } from 'vue';

export const componentName = 'CdsTab';
export default defineComponent({
  name: componentName,
  props: {
    hideSlider: {
      type: Boolean as PropType<boolean>,
      default: false
    },

    ...makeGroupItemProps({
      selectedClass: 'cds-tab--selected'
    }),
    ...makeTextProps(),
    ...makeDirectionProps(),
    ...makeIconProps(),
    ...makeSizeProps(),
    ...makeDisabledProps(),
    ...makeReadonlyProps(),
    ...makeLoadingProps()
  },
  emits: {
    'group:selected': (value: { value: boolean }) => true
  },
  setup(props, { slots, attrs, expose }) {
    const isSelected = shallowRef(false);

    function updateSlider({ value }: { value: boolean }) {
      isSelected.value = value;
    }

    useRender(() => {
      const btnProps = omit(props, ['direction', 'hideSlider']);

      return h(
        CdsButton,
        {
          symbol: CdsTabsSymbol,
          active: false,
          appearance: 'transparent',
          role: 'tab',
          class: 'cds-tab',
          tabindex: unref(isSelected) ? 0 : -1,
          ariaSelected: String(unref(isSelected)),
          ...btnProps,
          ...attrs,
          'onGroup:selected': updateSlider
        },
        {
          default: () => [
            slots.default?.() ?? props.text,
            !props.hideSlider &&
              h('div', {
                class: 'cds-tab__slider'
              })
          ],
          ...(slots.prepend ? { prepend: () => slots.prepend?.() } : {}),
          ...(slots.append ? { append: () => slots.append?.() } : {})
        }
      );
    });

    expose({
      updateSlider
    });

    return {};
  }
});
</script>
